import { IconWrapper } from '../runtime';
export default IconWrapper('folder_shared_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 19.3125C1.00736 19.3125 0 18.3051 0 17.0625V3C0 1.75736 1.00736 0.75 2.25 0.75C3.75 0.75 5.25 0.75 6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3C14.75 3 18.25 3 21.75 3C22.9926 3 24 4.00736 24 5.25V17.0625C24 18.3051 22.9926 19.3125 21.75 19.3125H2.25Z",
      "fill": "#0065DC"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 8.25C0 6.59315 1.34315 5.25 3 5.25H21C22.6569 5.25 24 6.59315 24 8.25V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.34315 22.5 0 21.1569 0 19.5V8.25Z",
      "fill": "#1983FF"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.6875 10.3125C16.6875 11.2963 15.89 12.0938 14.9062 12.0938C14.4475 12.0938 14.0293 11.9204 13.7136 11.6356L11.7031 12.7758C11.7742 13.0046 11.8125 13.2478 11.8125 13.5C11.8125 13.7752 11.7669 14.0398 11.6828 14.2866L13.6834 15.486C14.0025 15.1847 14.4328 15 14.9062 15C15.89 15 16.6875 15.7975 16.6875 16.7812C16.6875 17.765 15.89 18.5625 14.9062 18.5625C13.9225 18.5625 13.125 17.765 13.125 16.7812C13.125 16.678 13.1338 16.5768 13.1507 16.4783L11.0832 15.2388C10.6434 15.6709 10.0403 15.9375 9.375 15.9375C8.02881 15.9375 6.9375 14.8462 6.9375 13.5C6.9375 12.1538 8.02881 11.0625 9.375 11.0625C10.0639 11.0625 10.6861 11.3483 11.1294 11.8078L13.1583 10.6571C13.1365 10.5456 13.125 10.4304 13.125 10.3125C13.125 9.32874 13.9225 8.53125 14.9062 8.53125C15.89 8.53125 16.6875 9.32874 16.6875 10.3125Z",
      "fill": "white"
    }
  })]);
});